<template>
  <v-container fluid>
    <v-card>
      <v-card-title>
        Отчеты
      </v-card-title>

      <v-card-text>
        <div class="row">
          <div class="col">
            <custom-select
              label="Отчет"
              v-model="selectedReport"
              :items="reports"
              itemText="name"
              itemValue="id"
            />
          </div>
        </div>

        <div class="row">
          <div class="col" v-for="element in elements" :key="element.id">
            <div v-if="element.type === 'period'">
              <time-interval v-model="element.value" />
            </div>

            <div v-if="element.type === 'select'">
              <dynamic-selector
                v-model="element.value"
                :label="element.label"
                :multiple="element.multiple"
                :url="element.link"
                :method="element.method"
              />
            </div>

            <div v-if="element.type === 'submit_button'">
              <submit-button
                :label="element.label"
                @submit="submit(element)"
              />
            </div>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';
import moment from 'moment';
import DynamicSelector from '~/components/partials/reports/DynamicSelector.vue';
import SubmitButton from '~/components/partials/reports/SubmitButton.vue';
import TimeInterval from '~/components/pages/stat/elements/TimeInterval.vue';

export default {
  name: 'ReportsIndex',
  components: {
    DynamicSelector,
    SubmitButton,
    TimeInterval,
  },

  data() {
    return {
      reports: [],
      elements: [],
      selectedReport: null,
    }
  },

  watch: {
    selectedReport(newVal, oldVal) {
      if (newVal === oldVal) return;

      this.loadElements(newVal)
        .then(items => {
          this.elements = items;
        });
    },
  },

  computed: {
    payload() {
      let payload = {};

      for (const element of this.elements) {
        if (!element.value) continue;

        if (element.type === 'period') {
          payload[element.field_code] = [
            moment(element.value.start).format('YYYY-MM-DD HH:mm:ss'),
            moment(element.value.end).format('YYYY-MM-DD HH:mm:ss'),
          ];

          continue;
        }

        payload[element.field_code] = element.value;
      }

      return payload;
    },
  },

  methods: {
    ...mapActions('dynamic_reports', ['loadReports', 'loadElements', 'loadDynamicData']),

    getReports() {
      this.loadReports()
        .then(items => {
          this.reports = items;
        });
    },

    submit(element) {
      this.loadDynamicData({ url: element.link, method: element.method, data: this.payload, headers: { responseType: 'blob' } })
        .then(response => {
          if (response.headers['content-type'] === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
            this.utils.downloadXlsx(response);

            return;

            this.items = response.data;
          }
        })
        .catch(error => {
          console.error(error);
        });
    },
  },

  mounted() {
    this.getReports();
  },
}
</script>

<style scoped>

</style>